import { render, staticRenderFns } from "./InscripcioItem.vue?vue&type=template&id=399cafce&scoped=true&"
import script from "./InscripcioItem.vue?vue&type=script&lang=js&"
export * from "./InscripcioItem.vue?vue&type=script&lang=js&"
import style0 from "./InscripcioItem.vue?vue&type=style&index=0&id=399cafce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399cafce",
  null
  
)

export default component.exports